<ol class="breadcrumb-list">
	@if (showMobileBackButton && items?.length > 1) {
		<li class="back">
			<button
				class="back-button icon-btn ficon-arrow-left"
				type="button"
				(click)="onBack()"
				attr.aria-label="{{'common_back'| translate}}">
			</button>
		</li>
	}

	<ng-content select="li"></ng-content>
</ol>

<ng-content></ng-content>
